// extracted by mini-css-extract-plugin
export default {"info":"styles_info__yTH9D","close":"styles_close__wmX++"};